import { z } from "zod";

import { VariationDtoSchema } from "../../../../dtos/variations";
import { PluginOnsiteEditSchema } from "../onsite-edits";

export const PluginVariationSchema_2024_05_05 = VariationDtoSchema.omit({
  offer: true,
  includeProducts: true,
  excludeProducts: true,
  functionSyncError: true,
}).extend({
  onsiteEdits: z.optional(PluginOnsiteEditSchema.array()),
});

export type PluginVariationType_2024_05_05 = z.infer<
  typeof PluginVariationSchema_2024_05_05
> & {
  isExcluded?: boolean;
};
